const AVATARS = [1, 2, 3, 4, 5, 6].map((n) => `/voice-demo/avatars/${n}.png`)

const starterChips = (items) =>
  items.map(([title, q], i) => ({
    title,
    q,
    avatar: AVATARS[i % AVATARS.length]
  }))

const SCENARIOS_KO = [
  {
    key: 'furniture',
    tab: '가구몰',
    brand: '가구몰',
    business: '가구몰',
    agent: '하늘',
    role: '가구몰 AI 상담사',
    description: [
      '소파, 침대, 식탁, 수납가구 등, 가구 상품 카탈로그 문의,',
      '상품 추천, 배송 문의, 교환 및 환불 접수 안내를 진행해보세요.'
    ],
    orb: '/voice-demo/orb-tex-furniture.webp',
    chips: starterChips([
      ['배송지 변경', '배송지를 다른 주소로 바꾸고 싶어요'],
      ['배송일 변경', '배송일을 다음 주로 미룰 수 있을까요?'],
      ['파손 교환', '소파가 파손된 채로 왔어요, 교환할 수 있어요?'],
      ['배송 조회', '주문한 소파 배송 언제 와요?'],
      ['상품 추천', '거실에 둘 소파를 추천받고 싶어요'],
      ['반품 문의', '단순 변심 반품은 어떻게 진행하나요?']
    ])
  },
  {
    key: 'resort',
    tab: '리조트',
    brand: '리조트',
    business: '리조트',
    agent: '마루',
    role: '리조트 AI 컨시어지',
    description: [
      '리조트 예약, 부대시설 문의, 대관 상담, 컴플레인 상담,',
      '이벤트 및 콘서트 문의 등을 진행해보세요.'
    ],
    orb: '/voice-demo/orb-tex-resort.webp',
    chips: starterChips([
      ['식당 문의', '식당이 뭐가 있나요?'],
      ['취소 환불', '지금 취소하면 환불이 가능한가요?'],
      ['체크인 안내', '체크인 시간이 어떻게 되나요?'],
      ['객실 예약', '예약을 하고 싶어요'],
      ['대관 문의', '단체 대관이 가능한가요?'],
      ['주차 안내', '주차는 무료인가요?']
    ])
  },
  {
    key: 'homecare',
    tab: '홈케어',
    brand: '홈케어',
    business: '홈케어',
    agent: '은우',
    role: '홈케어 AI 매니저',
    description: [
      '가전, 가구 방문 수리, 청소, 관리 서비스 상담,',
      '예약 및 멤버십 상담, 비용 문의 등을 진행해보세요.'
    ],
    orb: '/voice-demo/orb-tex-homecare.webp',
    chips: starterChips([
      ['청소 예약', '에어컨 청소 예약하고 싶어요'],
      ['요금 문의', '에어컨 청소 비용은 얼마인가요?'],
      ['일정 문의', '방문 가능한 날짜를 알려주세요'],
      ['서비스 안내', '어떤 케어 서비스가 있는지 알려주세요'],
      ['예약 변경', '예약 변경이나 취소는 언제까지 가능한가요?'],
      ['방문 준비', '방문 전에 준비할 게 있나요?']
    ])
  }
]

const SCENARIOS_EN = [
  {
    key: 'furniture',
    tab: 'Retail',
    brand: 'Delight Home',
    business: 'Delight Home',
    agent: 'Ava',
    role: 'Delight Home AI sales associate',
    description: [
      'Compare two sofas, find one that fits your room and your budget, add delivery or setup, or book a free showroom visit.'
    ],
    orb: '/voice-demo/orb-tex-furniture.webp',
    chips: starterChips([
      ['Budget pick', 'What is your cheapest sofa?'],
      ['Will it fit', 'I have about 80 inches of space.'],
      ['Fabric and kids', 'I have young kids. Is the Cove stain proof?'],
      ['Delivery and setup', 'Can someone deliver it and set it up?'],
      ['See it in person', 'Can I try it before buying?'],
      ['Back to my cart', 'I was about to order the Cove, but it might be too big.']
    ])
  },
  {
    key: 'homecare',
    tab: 'Home Services',
    brand: 'Delight Home Services',
    business: 'Delight Home Services',
    agent: 'Sam',
    role: 'Delight Home Services AI service coordinator',
    description: [
      'Describe a heating, cooling, plumbing, or electrical problem, check that we cover your area, and book a visit or a free replacement estimate.'
    ],
    orb: '/voice-demo/orb-tex-homecare.webp',
    chips: starterChips([
      ['AC not cooling', "My AC isn't cooling."],
      ['Plumbing cost', 'What does a plumber cost?'],
      ['Electrical visit', "I need someone to look at an outlet. It's not an emergency."],
      ['New system', 'How much is a new heat pump?'],
      ['Free estimate', 'Is the estimate free?'],
      ['After hours', "Can you arrange an AC visit even though it's late?"]
    ])
  },
  {
    key: 'resort',
    tab: 'Healthcare',
    brand: 'Delight Health',
    business: 'Delight Health',
    agent: 'Nora',
    role: 'Delight Health AI shopping advisor',
    description: [
      'Ask about hearing products or glasses, get your questions about cost and commitment answered, and book a free 20-minute consultation.'
    ],
    orb: '/voice-demo/orb-tex-resort.webp',
    chips: starterChips([
      ['Where to start', 'My dad is thinking about hearing aids. Where do we start?'],
      ['Compare frames', 'I want to compare glasses.'],
      ['No obligation', 'Do I have to buy something?'],
      ['How long it takes', 'How long does it take?'],
      ['Bring someone', 'Can I come with my dad?'],
      ['Not an eye exam', 'Is that an eye exam?']
    ])
  }
]

export function getScenarios(agents, locale = 'ko') {
  const catalog = locale === 'en' ? SCENARIOS_EN : SCENARIOS_KO
  return catalog.map((scenario) => ({
    ...scenario,
    agentId: agents[scenario.key]
  }))
}

export function findScenario(scenarios, key) {
  return scenarios.find((s) => s.key === key) || scenarios[0]
}

export function formatDuration(totalSeconds) {
  const n = Math.max(0, Math.floor(totalSeconds || 0))
  const pad = (v) => String(v).padStart(2, '0')
  return `${pad(Math.floor(n / 60))}:${pad(n % 60)}`
}

export function startFailureMessage(error, copy) {
  const status = error?.status
  const code = error?.code
  if (status === 429) {
    return code !== undefined ? copy.agentRateLimit : copy.ipRateLimit
  }
  return copy.genericError
}

export function tokenExpired(token) {
  try {
    const payload = token.split('.')[1]
    if (!payload) return false
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/')
    const exp = JSON.parse(atob(normalized)).exp
    return typeof exp === 'number' && exp * 1000 < Date.now() + 30_000
  } catch {
    return false
  }
}

export function messageKey(msg) {
  return `${msg.role}:${msg.timestamp}`
}

export function upsertTranscription(log, segment) {
  const next = log.slice()
  const existing = next.findIndex((m) => m.id === segment.id)
  if (existing >= 0) {
    next[existing] = {
      ...next[existing],
      message: segment.text,
      isFinal: segment.isFinal
    }
    return next
  }

  const last = next[next.length - 1]
  if (
    last &&
    last.role === segment.role &&
    last.isFinal === false &&
    last.message &&
    (segment.text.startsWith(last.message) || last.message.startsWith(segment.text))
  ) {
    // Re-issue the segment id in place but keep timestamp — caption/transcript
    // keys are role:timestamp so a final merge does not remount the bubble.
    next[next.length - 1] = {
      ...last,
      id: segment.id,
      message: segment.text,
      isFinal: segment.isFinal
    }
    return next
  }

  next.push({
    id: segment.id,
    role: segment.role,
    message: segment.text,
    isFinal: segment.isFinal,
    timestamp: Date.now()
  })
  return next
}
